<template>
  <c-sidesheet :active="displaySidesheet" @close="onReset">
    <m-confirm ref="confirm" mode="danger" />

    <perfect-scrollbar
      class="employee-form"
      :class="{ 'employee-form-padding': employeeId, 'pb-40': !displayActionShadows }"
      :options="{ suppressScrollX: true, suppressScrollY: selectContainerOpened }"
      :watch-options="true"
      @ps-scroll-up="onScroll"
      @ps-y-reach-end="onScrollEnd"
    >
      <div class="employee-form-wrapper">
        <div class="employee-form__header-wrapper">
          <div class="employee-form__title-wrapper">
            <span v-if="!employeeId" class="employee-form__title">Добавление сотрудника</span>
            <template v-if="employeeId">
              <div class="sidesheet-title-employee-name">
                <span class="employee-form__title">Редактирование сотрудника&nbsp;</span>
                <span>{{ form.fullName }}</span>
              </div>
              <div class="text-15" :class="form.iikoCode ? 'd-flex' : 'd-none'">
                <span class="crm-user-label">Пользователь из CRM:</span>
                <span>{{ form.iikoCode }}</span>
              </div>
            </template>
          </div>

          <c-button
            v-if="employeeId"
            class="employee-remove-button"
            size="small"
            label="Удалить"
            :icon="{ icon: 'trash', color: 'secondary' }"
            @click="deleteEmployee"
          />
        </div>
        <div class="employee-form__row d-column">
          <div class="employee-form__row__item wide-input">
            <c-input
              v-model="form.fullName"
              floating-label="ФИО сотрудника"
              :max-length="255"
              :required-mark="true"
              :clearable="true"
              :required="errorMessages.fullName"
              :required-condition="!form.fullName"
              :class="{ 'required-field': errorMessages.fullName }"
            />
          </div>
          <div class="employee-form__row__item wide-input">
            <c-input
              v-model="form.fullNameDativeCase"
              floating-label="ФИО в дательном падеже (для договоров)"
              :max-length="255"
              :clearable="true"
            />
          </div>
          <div class="employee-form__row__item wide-input">
            <c-input
              v-model="form.fullNameGenitiveCase"
              floating-label="ФИО в родительном падеже (для договоров)"
              :max-length="255"
              :clearable="true"
            />
          </div>
        </div>
        <div class="employee-form__row mb-40">
          <div class="employee-form__row__item">
            <c-input
              v-model="form.citizenship"
              floating-label="Гражданство"
              type="select"
              :clearable="true"
              :searchable="true"
              :items="collections.citizenships"
              @container-opened="onSelectContainerOpen"
              @container-closed="onSelectContainerClose"
            />
          </div>
          <div class="employee-form__row__item mb-small-0">
            <c-input
              v-model="form.lawStatus"
              floating-label="Правовой статус"
              type="select"
              :clearable="true"
              :searchable="true"
              :items="lawStatuses"
              @container-opened="onSelectContainerOpen"
              @container-closed="onSelectContainerClose"
            />
          </div>
        </div>
        <div class="employee-form__row">
          <div class="employee-form__row__item mb-small-0">
            <c-input
              v-model="form.filial"
              floating-label="Филиал"
              type="select"
              :clearable="true"
              :searchable="true"
              :required-mark="true"
              :items="collections.filials"
              :required="errorMessages.filial"
              :required-condition="!form.filial"
              :class="{ 'required-field': errorMessages.filial }"
              @container-opened="onSelectContainerOpen"
              @container-closed="onSelectContainerClose"
            />
          </div>
          <div class="employee-form__row__item">
            <c-checkbox
              v-model="form.isAbleToWorkInDifferentFilials"
              class="mt-20"
              label="Может работать в нескольких филиалах"
            />
          </div>

          <div class="employee-form__row__item">
            <c-input
              v-model="form.company"
              floating-label="Юридическое лицо"
              type="select"
              :clearable="true"
              :searchable="true"
              :items="collections.companies"
              @container-opened="onSelectContainerOpen"
              @container-closed="onSelectContainerClose"
            />
          </div>
        </div>
        <div class="employee-form__row child-mb-24 mb-md-0">
          <div class="employee-form__row__item">
            <c-input
              v-model="form.workerStatus"
              floating-label="Статус сотрудника"
              type="select"
              :clearable="true"
              :searchable="true"
              :items="collections.workerStatuses"
              @container-opened="onSelectContainerOpen"
              @container-closed="onSelectContainerClose"
            />
          </div>
          <div class="employee-form__row__item" >
            <c-input
              v-if='showCharacteristic'
              v-model="form.workerCharacteristic"
              floating-label="Характеристика"
              type="select"
              :clearable="true"
              :searchable="true"
              :items="collections.workerCharacteristics"
              @container-opened="onSelectContainerOpen"
              @container-closed="onSelectContainerClose"
            />
          </div>
          <div class="employee-form__row__item">
            <c-input
              v-model="form.employmentStatus"
              floating-label="Статус трудоустройства"
              type="select"
              :clearable="true"
              :searchable="true"
              :items="collections.employmentStatuses"
              @container-opened="onSelectContainerOpen"
              @container-closed="onSelectContainerClose"
            />
          </div>
          <div class="employee-form__row__item">
            <c-input
              v-model="form.schedule"
              floating-label="Рабочий график"
              type="select"
              :clearable="true"
              :searchable="true"
              :items="collections.schedules"
              @container-opened="onSelectContainerOpen"
              @container-closed="onSelectContainerClose"
            />
          </div>
          <div class="employee-form__row__item mb-small-0">
            <c-input
              v-model="form.shiftType"
              floating-label="Тип смены"
              class="mb-small-0"
              type="select"
              :clearable="true"
              :items="collections.shiftTypes"
              @container-opened="onSelectContainerOpen"
              @container-closed="onSelectContainerClose"
            />
          </div>
          <div class="employee-form__row__item">
            <c-checkbox v-model="form.isAbleToWorkRemotely" class="mt-20" label="Может работать удаленно" />
          </div>
        </div>

        <div class="employee-form__row mb-small-0">
          <div class="employee-form__row__item wide-input">
            <c-input
              v-model="form.mentor"
              floating-label="Наставник"
              type="select"
              :clearable="true"
              :searchable="true"
              :items="collections.mentors"
              @container-opened="onSelectContainerOpen"
              @container-closed="onSelectContainerClose"
            />
          </div>
        </div>
        <div class="employee-form__row">
          <div class="employee-form__row__item mb-small-0 small-input">
            <c-input
              v-model="form.depositAmount"
              label="Размер депозита, ฿"
              placeholder="0"
              :max-length="255"
              :clearable="true"
            />
          </div>
          <div class="employee-form__row__item">
            <c-checkbox v-model="form.payOnPersonalAccount" class="mt-20" label="Начислять зп на личный счет" />
          </div>
        </div>

        <div class="employee-form__row">
          <div class="employee-form__row__item mb-small-0 small-input">
            <c-input
              ref="dateInput1"
              v-model="form.hiringDateOfficial"
              class="form-group inventory-item-form__issued-date"
              :class="{ 'form-group--invalid': issueDateError }"
              label="Дата трудоустройства"
              type="date"
              format="DD.MM.YYYY"
              :editable="true"
              icon="calendar"
              placeholder="00.00.0000"
              :input-text-condition="issueDateError"
              :icon-right="true"
              @invalidDate="setIssueDateFormatError"
            />
          </div>
          <div class="employee-form__row__item mb-small-0 small-input">
            <c-input
              ref="dateInput2"
              v-model="form.dismissalDate"
              class="form-group inventory-item-form__issued-date"
              :class="{ 'form-group--invalid': issueDateError2 }"
              label="Дата увольнения с работы"
              type="date"
              format="DD.MM.YYYY"
              :editable="true"
              icon="calendar"
              placeholder="00.00.0000"
              :input-text-condition="issueDateError2"
              :icon-right="true"
              @invalidDate="setIssueDateFormatError2"
            />
          </div>
        </div>

        <div class="employee-form__row">
          <div class="employee-form__row__item mb-small-0 small-input">
            <c-input
              ref="dateInput3"
              v-model="form.agreementDate"
              class="form-group inventory-item-form__issued-date date__agreement"
              :class="{ 'form-group--invalid': issueDateError3 }"
              label="Дата договора"
              type="date"
              format="DD.MM.YYYY"
              :editable="true"
              icon="calendar"
              placeholder="00.00.0000"
              :input-text-condition="issueDateError3"
              :icon-right="true"
              @invalidDate="setIssueDateFormatError3"
            />
          </div>
          <div class="employee-form__row__item mb-small-0 wide-input">
            <c-input
              v-model="form.agreementNumber"
              floating-label="Номер трудового договора"
              :max-length="255"
              :clearable="true"
              :required="serverErrors.argeement_number"
              :required-message="serverErrors.argeement_number"
            />
          </div>
        </div>

        <div class="employee-form__positions-wrapper">
          <div class="employee-form__subtitle">Должности</div>
          <div
            v-for="(position, positionIndex) in form.positions"
            :key="positionIndex"
            class="employee-form__row position-class child-mb-24 mb-0"
          >
            <div class="employee-form__row__item position-input position-width">
              <c-input
                v-model="form.positions[positionIndex].position"
                floating-label="Должность"
                type="select"
                :clearable="true"
                :required-mark="true"
                :searchable="true"
                :items="positionsCollection"
                :required="errorMessages.positions[positionIndex].position"
                :required-condition="!form.positions[positionIndex].position"
                :class="{ 'required-field': errorMessages.positions[positionIndex].position }"
                @container-opened="onSelectContainerOpen"
                @container-closed="onSelectContainerClose"
                @input="onPositionsInputReset(positionIndex)"
                @clearInput="onPositionsInputReset(positionIndex)"
              />
            </div>
            <div class="employee-form__row__item position-rank tiny-input w-sm-133">
              <c-input
                :ref="`rank-input-${positionIndex}`"
                v-model="form.positions[positionIndex].rank"
                floating-label="Разряд"
                type="select"
                :clearable="true"
                :searchable="true"
                :disabled="isRankSelectDisabled(positionIndex)"
                :items="getRanksCollection(positionIndex)"
                :required="errorMessages.positions[positionIndex].rank"
                :required-condition="!form.positions[positionIndex].rank"
                :class="{ 'required-field': errorMessages.positions[positionIndex].rank }"
                @container-opened="onSelectContainerOpen"
                @container-closed="onSelectContainerClose"
              />
            </div>
            <div class="employee-form__row__item position-specialty">
              <c-input
                :ref="`specialties-input-${positionIndex}`"
                v-model="form.positions[positionIndex].specialty"
                floating-label="Специальность"
                type="select"
                :clearable="true"
                :searchable="true"
                :disabled="isSpecialtySelectDisabled(positionIndex)"
                :items="getSpecialtiesCollection(positionIndex)"
                :required="errorMessages.positions[positionIndex].specialty"
                :required-condition="!form.positions[positionIndex].specialty"
                :class="{ 'required-field': errorMessages.positions[positionIndex].specialty }"
                @container-opened="onSelectContainerOpen"
                @container-closed="onSelectContainerClose"
              />
            </div>
            <div class="employee-form__row__item position-salary small-input w-sm-133">
              <c-input
                v-model="form.positions[positionIndex].salary"
                label="Оклад (для договоров)"
                placeholder="0"
                :max-length="255"
                :clearable="true"
              />
            </div>
            <c-button
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover',
                content: 'Удалить',
                placement: 'top',
              }"
              size="iconic"
              class="mt-20 position-remove-button"
              :icon="{ icon: 'trash', color: 'secondary' }"
              :disabled="form.positions.length === 1"
              @click="removePosition(positionIndex)"
            />
            <div class="mobile-position-remove-button mobile-only">
              <c-button
                size="small"
                label="Удалить"
                :icon="{ icon: 'trash', color: 'secondary' }"
                :disabled="form.positions.length === 1"
                @click="removePosition(positionIndex)"
              />
            </div>
          </div>
          <c-button
            size="small"
            class="add-position-button"
            :icon="{ icon: 'plus', color: 'primary' }"
            label="Добавить должность"
            :disabled="form.positions.length > 0 && !form.positions[form.positions.length - 1].position"
            @click="addPosition"
          />
        </div>
        <div class="employee-form__subtitle">Системы учета</div>
        <div class="employee-form__row child-mb-24">
          <div class="employee-form__row__item">
            <c-input
              v-model="form.timexServer"
              floating-label="Сервер Timex"
              type="select"
              :clearable="true"
              :searchable="true"
              :items="collections.timexServers"
              @container-opened="onSelectContainerOpen"
              @container-closed="onSelectContainerClose"
            />
          </div>
          <div class="employee-form__row__item">
            <c-input
              v-model="form.timexNumber"
              floating-label="Табельный номер Timex"
              :max-length="255"
              :clearable="true"
            />
          </div>
          <div class="employee-form__row__item small-input w-sm-full">
            <c-input
              v-model="form.iikoCode"
              floating-label="Код IIKO"
              :max-length="255"
              :clearable="true"
              :required="serverErrors.iiko"
              :required-message="serverErrors.iiko"
            />
          </div>
        </div>
      </div>

      <div v-show="displaySidesheet" class="employee-form__actions" :class="{ 'no-shadow': !displayActionShadows }">
        <responsive-apply-reset-actions
          :disable-submit="isSubmitDisabled || isSubmited || isPending"
          :shadows="displayActionShadows"
          @on-submit="onSubmit"
          @on-reset="onReset"
        />
      </div>

      <b-modal
        id="create-user-employee-modal-success"
        v-model="localActiveSuccessModal"
        size="custom-size"
        centered
        hide-footer
        hide-header
      >
        <div class="create-user-success-modal">
          <svg
            class="create-user-success-modal-close"
            width="15"
            height="16"
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            @click="localActiveSuccessModal = false"
          >
            <path
              d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
              fill="#8E9CBB"
            />
            <path
              d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
              fill="#8E9CBB"
            />
          </svg>
          <h2 class="create-user-success-modal-title">Сотрудник успешно добавлен</h2>
          <div v-if="record && record.fullName" class="create-user-success-modal-description">
            Создать пользователя для нового сотрудника <span class="create-user-success-modal-description-bold">{{ record.fullName.value }}</span>?
          </div>
          <responsive-apply-reset-actions
            class="create-user-success-modal-actions"
            submit-label="Создать"
            @on-submit="openCreateUserModal"
            @on-reset="localActiveSuccessModal = false"
          />
        </div>
      </b-modal>

      <m-create-user-for-employee
        id="create-user-for-employee"
        :active="isActiveCreateUserForEmployeeModal"
        :record="record"
        modal-title="Создать пользователя для сотрудника"
        @close="isActiveCreateUserForEmployeeModal = false"
      />

      <to-top-button element=".employee-form" />
    </perfect-scrollbar>
  </c-sidesheet>
</template>

<script>
import { mapState } from "vuex";
import Sidesheet from "@/components/sidesheet";
import Input from "@/components/controls2/Input";
import Button from "@/components/controls2/Button";
import Checkbox from "@/components/checkbox";
import ToTopButton from "@/components/to-top-button";
import Confirm from "@/components/modals/confirm-modal";
import CreateUserForEmployee from "@/pages/employees/m-create-user-for-employee";

import ResponsiveApplyResetActions from "@/components/responsive-apply-reset-actions";

import {
  defaultForm,
  defaultErrorMessages,
  defaultPosition,
  defaultPositionErrorMessages,
} from "@/pages/employees/employeeFormConstants";

export default {
  name: "employee-form",
  components: {
    "c-sidesheet": Sidesheet,
    "c-input": Input,
    "c-button": Button,
    "c-checkbox": Checkbox,
    "m-confirm": Confirm,
    "m-create-user-for-employee": CreateUserForEmployee,
    ToTopButton,
    ResponsiveApplyResetActions,
  },
  data() {
    return {
      form: { ...defaultForm },
      agreementNumberDisabled: false,
      isSubmited : false,
      errorMessages: { ...defaultErrorMessages },
      employeeId: null,
      showCharacteristic: true,
      displaySidesheet: false,
      displayActionShadows: true,
      isCollectionsLoading: false,
      isEmployeeLoading: false,
      selectContainerOpened: false,
      lawStatuses: [],
      formatErrors: {
        issueDate: false,
        issueDateFix: false,
        issueDate2: false,
        issueDateFix2: false,
        issueDate3: false,
        issueDateFix3: false,
      },
      serverErrors: {
        iiko: null,
        argeement_number: null,
      },
      localActiveSuccessModal: false,
      record: {},
      isActiveCreateUserForEmployeeModal: false,
      isPending: false,
      isDublicateModalOpen: false,
    };
  },

  computed: {
    ...mapState({
      collections: (state) => state.employeeForm.collections,
    }),

    positionsCollection() {
      const positions = [];
      Object.entries(this.collections.positions).forEach(([positionId, { name }]) => {
        positions.push({
          label: name,
          value: positionId,
        });
      });
      return positions;
    },
    ranksCollection() {
      const ranks = {};

      Object.entries(this.collections.positions).forEach(([positionCode, { categories }]) => {
        if (Array.isArray(categories)) {
          ranks[positionCode] = [];
          return;
        }
        ranks[positionCode] = [];
        Object.entries(categories).forEach(([categoryId, category]) => {
          ranks[positionCode].push({
            label: category,
            value: categoryId,
          });
        });
        ranks[positionCode].sort((a, b) => a.label>b.label ? 1 : -1);

      });
      return ranks;
    },
    specialtiesCollection() {
      const specialtiesObject = {};

      Object.entries(this.collections.positions).forEach(([positionCode, { specialties }]) => {
        if (Array.isArray(specialties)) {
          specialtiesObject[positionCode] = [];
          return;
        }
        specialtiesObject[positionCode] = [];
        Object.entries(specialties).forEach(([specialtyId, specialty]) => {
          specialtiesObject[positionCode].push({
            label: specialty,
            value: specialtyId,
          });
        });
      });

      return specialtiesObject;
    },
    isSubmitDisabled() {
      return JSON.stringify(this.form) === JSON.stringify(defaultForm);
    },
    issueDateError() {
      if (this.formatErrors.issueDate) return "Некорректный формат";
      return null;
    },    
    issueDateError2() {
      if (this.formatErrors.issueDate2) return "Некорректный формат";
      return null;
    },
    issueDateError3() {
      if (this.formatErrors.issueDate3) return "Некорректный формат";
      return null;
    },
  },

  watch: {
    "form.lawStatus" : function () {
      this.checkAgreementNumber();
    },

    "form.citizenship" : function (value) {
      if (value && value.value) {
        this.lawStatuses = this.collections.lawStatuses.filter((c) => c.citizenships.includes(value.value));
      } else {
        this.lawStatuses = this.collections.lawStatuses;
      }
      if (this.form.lawStatus && this.form.lawStatus.value) {
        if (this.lawStatuses.findIndex(s=>s.value==this.form.lawStatus.value)<0)
          this.form.lawStatus = null;
      }
    },

    "form.fullName": function (value) {
      if (value) {
        this.errorMessages.fullName = "";
      }
    },
    "form.filial": function (value) {
      this.checkAgreementNumber();
      if (value) {
        this.errorMessages.filial = "";
      }
    },
    "form.timexServer": function (value) {
      if (value) {
        // this.errorMessages.timexServer = "";
      }
    },
    "form.positions": {
      handler(value) {
        this.checkAgreementNumber();
        if (value.length) {
          value.forEach(({ position }, positionIndex) => {
            if (position) {
              this.errorMessages.positions[positionIndex].position = "";
              this.errorMessages.positions[positionIndex].rank = "";
              this.errorMessages.positions[positionIndex].specialty = "";
            }
          });
        }
      },
      deep: true,
    },
    "form.iikoCode": function () {
      this.serverErrors.iiko = null;
    },
    "form.company" : function () {
      this.checkAgreementNumber();
    },
    "form.agreementNumber" : function () {
      this.serverErrors.argeement_number = null;
    },
    "form.agreementDate" : function () {

      this.checkAgreementNumber();
    },
  },
  async created() {
    this.isCollectionsLoading = true;
    await this.$store.dispatch("employeeForm/fetchCollections");
    this.isCollectionsLoading = false;
  },
  methods: {
    checkAgreementNumber() {

      if (!this.form.agreementNumber) {
        const value = this.form;
        if (/* value.lawStatus && */ (value.filial || value.company) /* && value.positions && value.positions.length && value.positions[0].position */ && value.agreementDate) {
          const params = {
            // law_status : value.lawStatus.value,
            filial_id : value.filial ? value.filial.value : null,
            company_id :  value.company ? value.company.value : null,
            // post_code : value.positions[0].position.value,
            date : value.agreementDate,
            id : this.employeeId,
          };
          this.$store.dispatch("employeeForm/newAgreementNumber", params)
            .then(response => {
              if (response.number) {
                this.form.agreementNumber = response.number;
              }
            })
            .finally(response => {
            });
          //          console.log(params, value);
        }
      }
    },

    setIssueDateFormatError() {
      this.formatErrors.hiringDateOfficial = true;
      this.formatErrors.issueDateFix = true;
    },

    setIssueDateFormatError2() {
      this.formatErrors.dismissalDate = true;
      this.formatErrors.issueDateFix2 = true;
    },

    setIssueDateFormatError3() {
      this.formatErrors.agreementDate = true;
      this.formatErrors.issueDateFix3 = true;
    },

    onSelectContainerOpen() {
      // console.log('open select 12');
      //     const employeeForm = document.querySelector(".employee-form");
    //   const currentScrollPosition = employeeForm.scrollTop;
      //       console.log(currentScrollPosition);
      // this.selectContainerOpened = true;
      // employeeForm.style.setProperty("overflow", "scroll", "important");
      // employeeForm.scrollTo(0, currentScrollPosition);
      // employeeForm.style.setProperty("overflow", "hidden", "important");
    },
    openCreateUserModal() {
      this.localActiveSuccessModal = false;
      this.isActiveCreateUserForEmployeeModal = true;
    },
    onSelectContainerClose() {
      this.selectContainerOpened = false;
    },

    async open(employeeId = null) {
      this.displaySidesheet = true;
      this.$refs.dateInput1.setDateInputTypeDate('');
      this.$refs.dateInput2.setDateInputTypeDate('');

      if (employeeId) {
        this.employeeId = employeeId;
        await this.fetchEmployee();
      }

    },
    async fetchEmployee() {
      this.isEmployeeLoading = true;

      this.form = await this.$store.dispatch("employeeForm/getEmployeeInfo", this.employeeId);

      this.$refs.dateInput1.setDateInputTypeDate(this.form.hiringDateOfficial);
      this.$refs.dateInput2.setDateInputTypeDate(this.form.dismissalDate);
      this.$refs.dateInput3.setDateInputTypeDate(this.form.agreementDate);

      this.errorMessages.positions = [];
      const ps = [];
      this.form.positions.forEach((p) => {
        this.errorMessages.positions.push({ ...defaultPositionErrorMessages });
        ps.push([
          p.rank ? {label:p.rank.label, value:p.rank.value} : null,
          p.specialty ? {label:p.specialty.label, value:p.specialty.value} : null,
        ]);
      });

      const t = this;
      setTimeout(() =>{
        t.form.positions.forEach((p, i) => {
          p.rank = ps[i][0];
          p.specialty = ps[i][1];
        });
      }, 600);
    },

    addPosition() {
      console.log(defaultPosition, this.form);
      this.form.positions.push({ ...defaultPosition });
      this.errorMessages.positions.push({ ...defaultPositionErrorMessages });
    },
    removePosition(positionIndex) {
      const ranks = [];
      this.form.positions.forEach(p=>{ranks.push(p.rank);});
      this.form.positions.splice(positionIndex, 1);
      this.errorMessages.positions.splice(positionIndex, 1);

      const t= this;
      setTimeout(() => {
        let i = 0;
        ranks.forEach((rank, j) => {
          if (j != positionIndex) {
            t.form.positions[i].rank = rank;
            i++;
          }
        });
      }, 500);

    },
    onScroll() {
      this.displayActionShadows = true;
    },
    onScrollEnd() {
      this.displayActionShadows = false;
    },
    getSpecialtiesCollection(positionIndex) {
      if (!this.form.positions[positionIndex].position) {
        return [];
      }
      const positionCode = this.form.positions[positionIndex].position.value;
      return this.specialtiesCollection[positionCode];
    },
    getRanksCollection(positionIndex) {
      if (!this.form.positions[positionIndex].position) {
        return [];
      }
      const positionCode = this.form.positions[positionIndex].position.value;
      return this.ranksCollection[positionCode];
    },
    isRankSelectDisabled(positionIndex) {
      if (!this.form.positions[positionIndex].position) {
        return true;
      }
      const positionCode = this.form.positions[positionIndex].position.value;
      if (!positionCode) {
        return true;
      }
      return !this.ranksCollection[positionCode].length;
    },
    isSpecialtySelectDisabled(positionIndex) {
      if (!this.form.positions[positionIndex].position) {
        return true;
      }
      const positionCode = this.form.positions[positionIndex].position.value;
      if (!positionCode) {
        return true;
      }
      return !this.specialtiesCollection[positionCode].length;
    },

    async createEmployee() {
      await this.$store.dispatch("employeeForm/createEmployee", this.form)
        .then(response => {
          if (response.success) {
            this.$notify({
              group: "success-message",
              data: {
                textMessage: `Сотрудик <b>${this.form.fullName}</b> успешно добавлен`,
              },
            });
            this.record = {
              fullName: {
                value: this.form.fullName
              },
              id: response.model.id,
            };
            this.$emit("employee-submitted");
            this.onReset();
            this.localActiveSuccessModal = true;

          } else {
            const { errors } = response;
            if (errors && errors.agreement_number) {
              this.serverErrors.argeement_number = errors.agreement_number[0];
            }

            if (errors && errors.iiko_user_code) {
              const { iiko_user_code } = errors;
              if (iiko_user_code) {
                const [iikoError] = iiko_user_code;
                this.serverErrors.iiko = iikoError;
              }
            }
          }
        })
        .finally(response => {
          this.isPending = false;
        });
    },
    validate() {
      let isValid = true;

      if (Object.values(this.serverErrors).some(Boolean)) {
        isValid = false;
      }

      if (!this.form.fullName) {
        isValid = false;
        this.errorMessages.fullName = "Обязательное поле";
      }
      if (!this.form.filial) {
        isValid = false;
        this.errorMessages.filial = "Обязательное поле";
      }
      if (!this.form.timexServer) {
        // isValid = false;
        //  this.errorMessages.timexServer = "Обязательное поле";
      }

      this.form.positions = this.form.positions.filter((p, index) => p.position !=null);
      if (this.form.positions.length==0) {
        this.form.positions.push(defaultPosition);
      }

      this.form.positions.forEach(({ position, rank, specialty }, positionIndex) => {
        if (!position) {
          isValid = false;
          this.errorMessages.positions[positionIndex].position = "Обязательное поле";
          return;
        }
        const requiresRank = this.ranksCollection[position.value].length;
        const requiresSpecialty = this.specialtiesCollection[position.value].length;

        if (requiresRank && !rank) {
          // isValid = false;
          // this.errorMessages.positions[positionIndex].rank = "Обязательное поле";
        }
        if (requiresSpecialty && !specialty) {
          // isValid = false;
          // this.errorMessages.positions[positionIndex].specialty = "Обязательное поле";
        }
      });

      return isValid;
    },
    async onSubmit() {
      if (!this.validate()) {
        return;
      }

      if (this.employeeId) {
        this.isPending = true;
        await this.$store.dispatch("employeeForm/updateEmployee", {
          ...this.form,
          id: this.employeeId,
        })
          .then(response => {
            if (response.success) {
              this.$notify({
                group: "success-message",
                data: {
                  textMessage: `Настройки сотрудника <b>${this.form.fullName}</b> успешно обновлены`,
                },
              });
              this.$emit("employee-submitted");
              this.onReset();
            } else {
              const { errors } = response;
              if (errors && errors.agreement_number) {
                this.serverErrors.argeement_number = errors.agreement_number[0];
              }
              if (errors && errors.iiko_user_code) {
                const { iiko_user_code } = errors;
                if (iiko_user_code) {
                  const [iikoError] = iiko_user_code;
                  this.serverErrors.iiko = iikoError;
                }
              }
            }
          })
          .finally(response => {
            this.isPending = false;
          });
        
        return;
      }

      this.isPending = true;

      await this.$store.dispatch("employeeForm/checkEmployeeDuplicate", {fio: this.form.fullName})
        .then(response => {
          if (response.is_satisfied) {
            this.isDublicateModalOpen = true;
          } else {
            this.createEmployee();
          }
        })
        .catch((e)=>{
          console.log(e);})
        .finally(response => {
          this.isPending = false;
        });
    },
    onReset() {
      this.form = { ...defaultForm, positions: [{ ...defaultPosition }] };
      this.errorMessages = { ...defaultErrorMessages, positions: [{ ...defaultPositionErrorMessages }] };
      this.employeeId = null;
      this.displaySidesheet = false;
    },
    deleteEmployee() {
      this.$refs.confirm.open({
        title: "Удаление сотрудника",
        text: `Сотрудник <b>${this.form.fullName}</b> будет удален без возможности восстановления`,
        confirm: "Удалить",
        onConfirm: () => {
          this.$store.dispatch("employeeForm/deleteEmployee", this.employeeId);
          this.$emit("removed");
          this.onReset();
        },
      });
    },
    onPositionsInputReset(positionIndex) {
      this.$refs[`rank-input-${positionIndex}`][0].clear();
      this.$refs[`specialties-input-${positionIndex}`][0].clear();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";

.employee-form {
  overflow-x: hidden;
  height: 96vh;
  margin-top: -32px;

  @include onlyStandartMobile {
    padding: 10px 0 55px 0;
  }

  &__header-wrapper {
    display: flex;
    margin-bottom: 50px;
    @include mobileAndTablet {
      margin-bottom: 34px;
    }
    @include onlyStandartMobile {
      flex-direction: column;
      margin-bottom: 25px;
    }
  }

  &__title {
    font-size: 22px;
    font-weight: 500;

    @include onlyStandartMobile {
      font-size: 18px;
    }
  }

  &__subtitle {
    font-size: 18px;
    font-weight: 500;
    margin: 19px 0;
  }
  &__row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-bottom: 24px;

    &__item {
      width: 267px;
      margin-right: 30px;

      @include mobileAndTablet {
        width: 100%;
        margin-right: 0;
      }

      @include onlyStandartMobile {
        margin-bottom: 24px;
        margin-right: 0;
      }
    }
  }
  &__actions {
    height: 58px;
    padding: 10px 30px;
    position: sticky;
    bottom: 0;
    right: 0;
    box-shadow: 0 -4px 4px #00000025;
    background-color: #fff;
    transition: all 150ms ease;

    @include onlyStandartMobile {
      width: 100vw;
      position: static;
      height: auto;
      padding: 0;
      box-shadow: none;
    }
  }
  &__positions-wrapper {
    margin: 40px 0;
  }
}

.no-shadow {
  box-shadow: none;
}
.wide-input {
  width: 564px;

  @include mobileAndTablet {
    width: 100%;
    margin-right: 0;
  }
}
.small-input {
  width: 168px;
}
.tiny-input {
  width: 68px;
  @include mobileAndTablet {
    width: 93px;
  }
}
.position-salary {
  @include mobileAndTablet {
    width: 125px;
  }
}
.position-width {
  width: 350px;

  @include mobileAndTablet {
    width: 462px;
  }
  @include onlyStandartMobile {
    width: 100%;
  }
}
.position-class {
  @include onlyStandartMobile {
    border-bottom: 1px solid $color-border-alt;
    margin-bottom: 25px !important;

    &:last-child {
      margin-bottom: 0 !important;
    }
  }
}
.add-position-button {
  margin-top: -5px;

  @include onlyStandartMobile {
    margin-top: 19px;
  }
}
.w-sm-133 {
  @include onlyStandartMobile {
    width: 133px;
  }
}
.d-column {
  flex-direction: column;
  align-items: start;

  & > div {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
.mobile-position-remove-button {
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  width: 100%;

  @include onlyStandartMobile {
    margin-bottom: 19px !important;
  }
}

@media (min-width: 481px) and (max-width: 920px) {
  .position-class {
    & .position-input {
      order: 0;
    }
    & .position-rank {
      order: 1;
    }
    & .position-specialty {
      order: 3;
    }
    & .position-salary {
      order: 4;
    }
    & .position-remove-button {
      order: 2;
    }
  }
}

.child-mb-24 > div {
  margin-bottom: 24px;
}
.mobile-only {
  display: none;
  @include onlyStandartMobile {
    display: flex;
  }
}
.mb-md-80 {
  margin-bottom: 80px;
  @include onlyStandartMobile {
    margin-bottom: 0;
  }
}
.desktop-only {
  display: flex;
  @include onlyStandartMobile {
    display: none;
  }
}
.mb-0 {
  margin-bottom: 0;
}
.mt-20 {
  margin-top: 20px;
}
.mb-40 {
  margin-bottom: 40px;
}
.mb-md-0 {
  @include mobileAndTablet {
    margin-bottom: 0;
  }
}
.mb-small-0 {
  @include onlyStandartMobile {
    margin-bottom: 0 !important;
  }
}
.pb-40 {
  padding-bottom: 40px;
}
.w-sm-full {
  @include onlyStandartMobile {
    width: 100%;
  }
}
.required-field {
  margin-bottom: 20px;
}
.position-rank.tiny-input{
  width:130px;
}
::v-deep .ps:hover > .ps__rail-y,
::v-deep .ps--scrolling-y > .ps__rail-y {
  opacity: 1 !important;
}
::v-deep .ps__rail-y {
  width: 4px;
  @include onlyStandartMobile {
    position: fixed !important;
    right: 0px !important;
  }
  &:hover > .ps__thumb-y,
  &.ps--clicking .ps__thumb-y {
    width: 5px;
    background-color: $pink;
  }
}
::v-deep .ps__thumb-y {
  width: 4px;
  background-color: $pink;
  opacity: 1 !important;
}
::v-deep #pagetop {
  bottom: 45px;
}
::v-deep .responsive-actions {
  margin-top: 0;
  z-index: 999;

  @include onlyStandartMobile {
    padding-left: 20px;
  }

  @include onlyExtraSmall {
    padding-left: 0;
    margin-left: 0 !important;
  }
}
::v-deep .sidesheet__title {
  @include onlyStandartMobile {
    font-size: 18px;
  }
}
::v-deep .c-button_size_small.c-button_icon_trash {
  width: 104px;
}
::v-deep .position-rank .c-input-required-text {
  white-space: normal !important;
}
::v-deep .sidesheet__wrapper {
  padding: 40px 0;
}
::v-deep .sidesheet__header {
  padding: 0 30px;
}

/deep/ {
  @include onlyStandartMobile {
    .sidesheet__wrapper {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .sidesheet__content {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}

.employee-form-wrapper {
  padding: 0 30px;
  @include onlyStandartMobile {
    padding: 0 20px;
  }
}
.employee-remove-button {
  margin-left: auto;
  margin-top: 5px;
  @include onlyStandartMobile {
    margin-top: 15px;
    margin-left: 0;
  }
}

.sidesheet-title-employee-name {
  font-size: 22px;
  @include onlyStandartMobile {
    display: flex;
    flex-direction: column;
    font-size: 18px;
  }
}
.d-flex {
  display: flex;
  align-items: center;
}
.d-none {
  display: none;
}
.text-15 {
  font-size: 15px;
}
.crm-user-label {
  color: $color-label;
  font-weight: 400;
  margin-right: 5px;
}

.create-user-success-modal {
  &-close {
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 12px;
  }

  &-title {
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    margin: 0 0 25px;
  }

  &-description {
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 15px;

    &-bold {
      font-weight: 500;
    }
  }

  &-item {
    display: flex;
    align-items: center;

    &-name {
      color: #8E9CBB;
      font-size: 15px;
      line-height: 150%;
      min-width: 60px;
      margin-right: 5px;
    }

    &-value {
      font-size: 15px;
      font-weight: 500;
      line-height: 150%;
    }
  }

  &-additional-info {
    font-family: Fira Sans;
    font-size: 15px;
    line-height: 18px;

    &-link {
      cursor: pointer;
      text-decoration: none;
    }
  }

  &-actions {
    justify-content: flex-end;
    margin-top: 20px;
  }

  @media screen and (max-width: 700px) {
    padding-bottom: 32px;

    &-actions {
      position: absolute;
      left: 0;
    }
  }
}

.date__agreement {
  margin-top: 6px;
}

</style>

<style>
.employee-form__row__item.position-salary .c-input-wrapper{
  min-height: 35px !important;
}
</style>